// ANCHOR Base
import { Button, SIZE } from 'baseui/button';

// ANCHOR Models
import { useUpdateFormQuestionFormSubmitPayload } from '@lyon/scoped-models/form/update/UpdateFormQuestionForm';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Styles
import { BUTTON } from './styles';

export const LyonUpdateFormContentSaveButton = constant(() => {
  const [
    submit, isDisabled, loading,
  ] = useUpdateFormQuestionFormSubmitPayload();

  return (
    <div>
      <Button
        size={SIZE.default}
        type="button"
        overrides={BUTTON}
        onClick={submit}
        isLoading={loading}
        disabled={isDisabled}
      >
        Save Changes
      </Button>
    </div>
  );
});
